export default "__VITE_ASSET__CKBiVDoY__"